import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { AuthFormLocation } from '@as-react/common-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { DateFormat } from '../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useCheckoutState } from '../../../context/CheckoutContext';
import { useCheckoutLogin } from '../../../hooks/useCheckoutLogin';
import { useCreateAccount } from '../../../hooks/useCreateAccount';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import CustomerUtil from '../../../util/CustomerUtil';
import { formatDate } from '../../../util/DateUtil';
import { getLoginError } from '../../../util/LoginUtil';
import { ScrollUtil } from '../../../util/ScrollUtil';
import { prepareAddressByCountry } from '../../form/address-fields/addressFields.utils';
import { PERSONAL_DETAILS_FORM_NAME, PersonalDetailsRegistrationForm, } from './PersonalDetailsRegistrationForm';
export const PersonalDetailsRegistration = () => {
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.checkout]);
    const { lang, mainWebShop } = useAemConfig();
    const [state, dispatch] = useCheckoutState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { checkoutLogin, errorMessage: loginErrorMessage } = useCheckoutLogin();
    const { createAccount, errorMessage: createAccountErrorMessage } = useCreateAccount();
    const reduxDispatch = useDispatch();
    const loginError = getLoginError(loginErrorMessage || '', t, mainWebShop);
    const createError = createAccountErrorMessage ? t(createAccountErrorMessage) : undefined;
    const handleSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setIsSubmitting(true);
        const customerData = Object.assign({ email: state.login.email, password: state.login.password, idTitle: Number(values.title), firstName: values.firstName || '', lastName: values.lastName || '', middleName: values.middleName, gender: values.gender || '', dateOfBirth: values.dateOfBirth
                ? formatDate(values.dateOfBirth, DateFormat.DD_MM_YYYY.value)
                : values.dateOfBirth, mobilePhoneNumber: (_a = CustomerUtil.convertPhoneNumberPrefix(values.mobilePhoneNumber, '+', '00')) !== null && _a !== void 0 ? _a : '', language: lang, preference: {
                preference: false,
                exploreMoreNewsletter: Boolean(values.newsletter),
            }, address: prepareAddressByCountry(values.address) }, (values.invoice
            ? {
                finance: {
                    needInvoice: true,
                    vatNumber: values.finance.vatNumber,
                    companyName: values.finance.companyName,
                    department: values.finance.departmentName,
                    isVat: values.finance.isVat,
                    isViesVerified: values.finance.isViesVerified,
                },
            }
            : {}));
        const result = yield createAccount(customerData);
        if (result) {
            dispatch({ type: 'registration_passed' });
            checkoutLogin({
                username: state.login.email,
                password: state.login.password,
                keepSignedIn: false,
                location: AuthFormLocation.CHECKOUT_V2,
            });
        }
    });
    useEffect(() => {
        reduxDispatch(analyticsActions.checkoutPersonalDetails());
    }, []);
    useEffect(() => {
        if (loginError || createError) {
            ScrollUtil.scrollToErrorElement(document.querySelector(`[name="${PERSONAL_DETAILS_FORM_NAME}"]`));
            setIsSubmitting(false);
        }
    }, [loginError, createError]);
    return (_jsx(PersonalDetailsRegistrationForm, { onSubmit: handleSubmit, isLoading: isSubmitting, errorFeedback: loginError || createError }));
};
